import { InvoiceStatus } from '../types';
import { UrlUtils } from '../utils';
export { InvoiceStatus };
export const useSuccessPageUrl = _ref => {
  let {
    siteGuid,
    domainName,
    ppType,
    referralAdditionalInfo = 'PremiumPurchasePlan',
    successUrl,
    planName,
    cycle
  } = _ref;
  const baseUrl = '';
  const referrer = 'PremiumPurchasePlan';
  const buildSuccessPageUrl = (invoiceId, queryParams, route) => {
    const url = UrlUtils.buildUrl({
      url: `${baseUrl}/premium-success-pages/${route ?? ''}${invoiceId}`,
      params: queryParams
    });
    return url;
  };
  const buildCustomSuccessUrl = invoiceId => {
    if (!successUrl) {
      return undefined;
    }
    const params = {
      invoiceId,
      planName,
      cycle,
      paymentType: 'IMMIDIATE'
    };
    return UrlUtils.buildUrl({
      url: successUrl,
      params
    });
  };
  const getPremiumSuccessPageUrl = invoiceId => {
    const queryParams = {
      siteId: siteGuid,
      referrer: 'PremiumPurchasePlan',
      referralAdditionalInfo,
      domainName
    };
    return buildSuccessPageUrl(invoiceId, queryParams, 'premium-plan-success/');
  };
  const getSepaSuccessPageUrl = invoiceId => {
    const queryParams = {
      siteId: siteGuid,
      referrer
    };
    return buildSuccessPageUrl(invoiceId, queryParams);
  };
  const getBoletoSuccessPageUrl = (invoiceId, _ref2) => {
    let {
      eventAggregator
    } = _ref2;
    const queryParams = {
      siteId: siteGuid,
      referrer,
      ppType,
      domainName,
      externalSessionId: eventAggregator
    };
    return buildSuccessPageUrl(invoiceId, queryParams);
  };
  const getSuccessPageUrl = _ref3 => {
    let {
      invoiceStatus,
      invoiceId,
      eventAggregator,
      biHandler
    } = _ref3;
    // TODO: Should this logic be here? It can be used in Sunrise as well, but it doesn't look good
    let url;
    if (invoiceStatus === InvoiceStatus.PAYMENT_IN_PROGRESS) {
      var _biHandler;
      url = getSepaSuccessPageUrl(invoiceId);
      biHandler == null || (_biHandler = biHandler('sepa')) == null || _biHandler({});
    } else if (invoiceStatus === InvoiceStatus.DRAFT) {
      var _biHandler2;
      url = getBoletoSuccessPageUrl(invoiceId, {
        eventAggregator
      });
      biHandler == null || (_biHandler2 = biHandler('boleto')) == null || _biHandler2({});
    } else if (invoiceId) {
      if (successUrl) {
        var _biHandler3;
        url = buildCustomSuccessUrl(invoiceId);
        biHandler == null || (_biHandler3 = biHandler('custom')) == null || _biHandler3({
          customSuccessUrl: url
        });
      } else {
        var _biHandler4;
        url = getPremiumSuccessPageUrl(invoiceId);
        biHandler == null || (_biHandler4 = biHandler('default')) == null || _biHandler4({});
      }
    }
    return url;
  };
  return {
    getSuccessPageUrl
  };
};
//# sourceMappingURL=useSuccessPageUrl.js.map